import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言文件
import enTranslation from './locales/en';
import zhTranslation from './locales/zh';
import esTranslation from './locales/es';
import frTranslation from './locales/fr';
import jaTranslation from './locales/ja';

// 初始化i18next
i18n
  // 使用语言检测器
  .use(LanguageDetector)
  // 使用react-i18next
  .use(initReactI18next)
  // 初始化配置
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      zh: {
        translation: zhTranslation
      },
      es: {
        translation: esTranslation
      },
      fr: {
        translation: frTranslation
      },
      ja: {
        translation: jaTranslation
      }
    },
    fallbackLng: 'en', // 备用语言
    lng: 'en', // 默认语言
    debug: false, // 调试模式

    interpolation: {
      escapeValue: false, // 不转义HTML
    },

    // 持久化语言设置到本地存储
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n; 